import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { FC } from 'react';
interface EyeToDetailProps {
  route: string;
  title?: string;
}
const EyeToDetail: FC<EyeToDetailProps> = ({ route, title }) => {
  return (
    <Link
      to={route}
      className="text-blue-600 hover:text-blue-800 flex items-center justify-center"
    >
      <FontAwesomeIcon
        icon={faEye}
        style={{ fontSize: '15px' }}
        title={title || 'Ver Detalle'}
      />
    </Link>
  );
};

export default EyeToDetail;